import Axios from 'axios';
import {FRONTEND_API, FRONTEND_API_CACHED} from '../utils/variables';

export function updateSingleProductApi(amount, productId, currency, cartId) {
    const data = {
        amount: amount,
        productId: productId,
        currency: currency,
        cartId: cartId
    };

    return Axios.patch(`${FRONTEND_API}/cart`, data);
}

export function updatePackageApi(packageId, packageData, currency, cartId) {
    const data = {
        packageId: packageId,
        packageData: packageData,
        currency: currency,
        cartId: cartId
    };

    if (data.packageData) {
        delete data.packageData.products;
    }

    return Axios.patch(`${FRONTEND_API}/cart`, data);
}

export function updateCartEmailApi(email, cartId) {
    const data = {
        email: email,
        cartId: cartId
    };

    return Axios.post(`${FRONTEND_API}/cart/email`, data);
}

export function refreshCartApi(currency, cartId) {
    const data = {
        currency: currency,
        cartId: cartId
    };

    return Axios.post(`${FRONTEND_API}/cart`, data);
}

export function fetchCartGiftsApi(country) {
    return Axios.get(`${FRONTEND_API_CACHED}/gifts/${country}`);
}
